import { render } from "./TableLeaveStatus.vue?vue&type=template&id=704cc03a&scoped=true"
import script from "./TableLeaveStatus.vue?vue&type=script&lang=js"
export * from "./TableLeaveStatus.vue?vue&type=script&lang=js"

import "./TableLeaveStatus.vue?vue&type=style&index=0&id=704cc03a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704cc03a"]])

export default __exports__